import type { CsvAnalysis } from 'troppus-common/shared';

import type { FormValues } from './types';

/** 問題なければ null、ユーザー向けエラー文言があればその文字列 */
export function validateCreateTableDefinitionSubmit(values: FormValues, analysis: CsvAnalysis | null): string | null {
  const trimmedName = values.displayName.trim();
  if (!trimmedName) return '表示名を入力してください';
  if (!values.sourceSystemId) return 'ソースシステムを選択してください';
  if (!analysis || values.columns.length === 0) return 'CSV を解析してください';
  if (values.contractUkColumns.length < 1) return '契約の一意キーとなる列を 1 つ以上選んでください';

  const contractCols = values.columns.filter((c) => c.destination === 'contract').map((c) => c.name);
  const customerCols = values.columns.filter((c) => c.destination === 'customer').map((c) => c.name);
  const invalidContractUk = values.contractUkColumns.some((n) => !contractCols.includes(n));
  if (invalidContractUk) return '契約の一意キーは「契約」にマップした列から選んでください';

  if (values.customerUkEnabled) {
    if (values.customerUkColumns.length < 1) return '顧客の一意キーを指定する場合、列を 1 つ以上選んでください';
    const invalidCust = values.customerUkColumns.some((n) => !customerCols.includes(n));
    if (invalidCust) return '顧客の一意キーは「顧客」にマップした列から選んでください';
  }
  return null;
}
